import { render, staticRenderFns } from "./hotSaleSwiper.vue?vue&type=template&id=113f2cbf&scoped=true&"
import script from "./hotSaleSwiper.vue?vue&type=script&lang=js&"
export * from "./hotSaleSwiper.vue?vue&type=script&lang=js&"
import style0 from "./hotSaleSwiper.vue?vue&type=style&index=0&id=113f2cbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f2cbf",
  null
  
)

export default component.exports